import { useState } from 'react';

export const useModalState = (defaultValue?: boolean) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(
    defaultValue ?? false
  );

  const setOpenModal = () => setIsModalOpen(true);
  const setCloseModal = () => setIsModalOpen(false);
  const setModalVisibility = (value?: boolean) =>
    setIsModalOpen(value ?? false);

  return {
    isModalOpen,
    setOpenModal,
    setCloseModal,
    setModalVisibility
  };
};

export default useModalState;
